module.exports = __webpack_public_path__ + "static/media/P921-sq.37d0c40c.jpeg";